import { GridColumnVisibilityModel } from '@mui/x-data-grid-pro';

export type ColumnWithLegacyHide = { field?: string; hide?: boolean };

export function buildColumnVisibilityModel(
  columns: ColumnWithLegacyHide[],
): GridColumnVisibilityModel {
  const model: GridColumnVisibilityModel = {};
  columns.forEach((col) => {
    if (col && col.field && col.hide === true) {
      model[col.field] = false;
    }
  });
  return model;
}
